import React from "react";
import ShipmentListItem from "../../components/shipment/ShipmentList/ShipmentListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const ShipmentListPage = ()  => {

    useTitle(t`List Shipment`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <ShipmentListItem showAdd={true} {...query} />
        </Box>
    )
}

export default ShipmentListPage;
